<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Facturas Electrónicas</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input id="fechainicio" placeholder="Fecha inicio" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="150px">
                <input id="fechafin" placeholder="Fecha final" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="150px">
                <select v-model="tipo" class="form-control">
                  <option value="1">ACTIVAS</option>
                  <option value="2">ANULADAS</option>
                  <option value="3">TODAS</option>
                  <option value="4">NC PARCIALES</option>
                </select>
              </td>
              <td>
                <button class="btn btn-warning" type="submit" @click="getReporteEquipos">
                  Consultar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="containter-table" class="containter-table">
        <table id="table2" width="100%" class="display nowrap" style="width: 100%">
          <thead>
            <tr>
              <th width="130px">Fecha ELE</th>
              <th width="100px">Consecutivos</th>
              <th class="text-center">Nit</th>
              <th>Cliente</th>
              <th class="text-center">Productos</th>
              <th class="text-center">Precio</th>
              <th width="60px" class="text-center">Impuesto</th>
              <th width="80px" class="text-center">Venta</th>
              <th>Anterior</th>
              <th class="text-center">Código</th>
              <th width="80px" class="text-center">Estado</th>
              <th width="30px" class="text-center">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>
      <div>
        <table width="300px" class="table font-oswald">
          <tbody>
            <tr>
              <td class="subtable" width="150px">TRANSACCIONES</td>
              <td class="subtable b text-right">
                {{ totalventas }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL CANTIDAD</td>
              <td class="subtable b text-right">
                {{ fcantidad }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL IMPUESTOS</td>
              <td class="subtable b text-right">
                {{ ftotalimpuestos }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL VENTAS</td>
              <td class="subtable b text-right">
                {{ ftotales }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="myChange" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">

            <div class="modal-header">
              <h5 class="modal-title">Info</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div style="padding: 20px">
                Detalle del error:<br />
                {{ mensajeError }}
              </div>
            </div>

            <!-- NUEVO FOOTER -->
            <div class="modal-footer">


              <!-- Botón reprocesar: llama a un método Vue -->
              <button type="button" class="btn btn-primary" @click="reprocesarError">
                Borrar este mensaje y reenviar
              </button>

              <!-- Botón cancelar: solo cierra el modal -->
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>


            </div>
          </div>
        </div>
      </div>


      <div id="ModalCancel" class="modal" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Motivo de Cancelación</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="titles-options">
                ¿Desea cancelar la factura {{ factura_eliminar }}?
              </div>
              <div style="font-size: 10px; text-align: center">
                {{ this.factura_eliminar_uniqueid }} ||
                {{ this.factura_eliminar_remotoid }}
              </div>
              <div style="padding: 8px">
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="01"
                      v-model="opcionSeleccionada" />
                    01-Comprobante emitido con errores con relación
                  </div>
                </label>
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="02"
                      v-model="opcionSeleccionada" />
                    02-Comprobante emitido con errores sin relación
                  </div>
                </label>
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="03"
                      v-model="opcionSeleccionada" />
                    03-No se llevó a cabo la operación
                  </div>
                </label>
                <label class="label-options">
                  <div>
                    <input type="radio" class="input-options" name="cancelacion" value="04"
                      v-model="opcionSeleccionada" />
                    04-Operación nominativa relacionada a la factura global
                  </div>
                </label>
              </div>
              <div style="padding: 8px">
                <table width="100%">
                  <tbody>
                    <tr>
                      <td class="left">
                        <button class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                          Cerrar
                        </button>
                      </td>
                      <td class="right">
                        <button class="btn btn-danger" v-if="factura_eliminar_remotoid"
                          @click="enviarCancelacionFactura" :disabled="desabilitarBotonCancelar">
                          Sí, Cancelar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal para inactivar factura -->
      <div id="ModalInactivar" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Inactivar Factura</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div style="font-size: 15px; text-align: center;">
                ¿Está seguro que desea inactivar la factura
                <span style="color: #c00">
                  {{ factura_eliminar }}
                </span>
              </div>
              <p style="padding: 20px 20px 0px 20px; font-size: 13px;">
                Al inactivar la factura, confirma que <b>no se encuentra activa en el SAT</b> o <b>nunca se llegó a
                  emitir</b>.<br>
                Esta acción <b>cancelará el consecutivo actual</b> y <b>liberará las ventas asociadas</b> a esta
                factura.<br>
                <b>Esta acción no se puede deshacer.</b>
              </p>
              <p>
                <label class="font-weight-bold small">Observación (motivo de inactivación)</label>
                <textarea v-model="motivoInactivacion" class="form-control" rows="3"
                  placeholder="Describa brevemente el motivo"></textarea>
                <small class="text-muted">Esta observación quedará registrada junto con la inactivación.</small>
              </p>
              <p class="text-danger font-weight-bold" v-if="mensajeInactivacion">
                {{ mensajeInactivacion }}
              </p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" class="btn btn-danger" @click="confirmarInactivarFactura">Sí</button>
            </div>
          </div>
        </div>
      </div>


      <!-- Modal cambiar opciones en factura -->
      <div id="ModalOpciones" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Cambiar Opciones de Factura</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

              <div>Tipo de venta</div>
              <div>
                <select class="form-control" v-model="tipo_venta">
                  <option :key="item._id" :value="item._id" v-for="item in lista_tipo_venta">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>

              <div>Método de pago</div>
              <div>
                <select class="form-control" v-model="metodo_pago">
                  <option :key="item._id" :value="item._id" v-for="item in lista_metodo_pago">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>


              <div>Uso de CFDI</div>
              <div>
                <select class="form-control" v-model="uso_cfdi">
                  <option :key="item._id" :value="item._id" v-for="item in lista_uso_cfdi">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>


              <div>Forma de pago</div>
              <div>
                <select class="form-control" v-model="forma_pago">
                  <option :key="item._id" :value="item._id" v-for="item in lista_forma_pago">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>


              <div>Periodicidad</div>
              <div>
                <select class="form-control" v-model="perioricidad" :disabled="desabilitarPerioricidad">
                  <option :key="item._id" :value="item._id" v-for="item in lista_perioricidad">
                    {{ item.codigo }} - {{ item.descripcion }}
                  </option>
                </select>
              </div>

              <div>
                <div>Observaciones</div>
                <div>
                  <input class="form-control" v-model="observaciones" />
                </div>
              </div>

              <p class="text-danger font-weight-bold" v-if="mensajCambioOpciones">
                {{ mensajCambioOpciones }}
              </p>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" class="btn btn-danger" @click="confirmarCambioOpcionesFactura">Sí</button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";
import FacturadorService from "../Facturador/FacturadorService";

export default {
  data() {
    return {
      GLOBAL,
      reporteService: null,
      facturadorService: null,
      person: null,
      empresa: "",
      cache: false,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totalimpuestos: 0,
      totales: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
      tipo: "1",
      loading: true,
      datatable: null,
      clientes: [],
      cliente: "",
      mensajeError: "",
      factura_eliminar: null,
      factura_eliminar_item: null,
      factura_eliminar_uniqueid: null,
      factura_eliminar_remotoid: null,
      opcionSeleccionada: "",
      desabilitarBotonCancelar: false,
      isCheckedReasignarTercero: false,
      mensajeAnulacion: "",
      motivoInactivacion: "",
      mensajeInactivacion: "",

      lista_metodo_pago: [],
      metodo_pago: null,

      lista_forma_pago: [],
      forma_pago: null,

      lista_uso_cfdi: [],
      uso_cfdi: null,

      lista_tipo_venta: [],
      tipo_venta: null,

      lista_perioricidad: [],
      perioricidad: null,
      desabilitarPerioricidad: false,
      observaciones: "",

      mensajCambioOpciones: "",

      // NUEVO: para saber qué factura está asociada al error del modal
      factura_error_item: null,
    };
  },

  computed: {
    isMX() { return this.GLOBAL.COUNTRY === "MX"; },
    isCO() { return this.GLOBAL.COUNTRY === "CO"; }
  },

  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    if (GLOBAL.COUNTRY == "MX") {
      this.FACTOR_CONVERSION = this.person.parametros.factor_m3;
    }
    this.empresa = this.person.empresas;
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.reporteService = new ReporteService();
    this.facturadorService = new FacturadorService();
    this.reporte = [];
  },

  mounted() {
    this.reporte = [];

    this.initDateInputs();

    var fechaActual = new Date();
    var vm = this;

    this.datatable = $("#table2").DataTable({
      data: this.reporte,
      responsive: true,
      autoWidth: false,
      scrollX: true,
      scrollCollapse: true,
      columns: [
        { data: "fecha" },
        {
          data: null,
          render: function (data, type, row) {
            return row.prefijo + "-" + row.consecutivo;
          },
        },
        { data: "tercero_nit", class: "text-right" },
        { data: "tercero_nombre" },
        {
          render: (data, type, row) => {
            const m = new Map();
            (row.productos || []).forEach(p => {
              const k = p._id;
              if (!m.has(k)) m.set(k, { ...p });
              else m.get(k).cantidad += p.cantidad;
            });

            const parts = [];
            for (const p of m.values()) {
              const cant = this.GLOBAL.FORMATO_NUMBER(p.cantidad);
              const unidad = `<span class='font11'>${p.unidad_codigo}</span>`;
              let line = `[${cant}${unidad}] `;
              if (this.isMX) {
                if (p._id == 1) {
                  const m3 = this.GLOBAL.FORMATO_NUMBER(
                    p.cantidad / this.person.parametros.factor_m3
                  );
                  line += `[${m3}<span class='font11'>m3</span>] `;
                }
              }
              line += `${p.producto_nombre} <br/>`;
              parts.push(line);
            }
            return parts.join("");
          }
        },
        {
          class: "text-right",
          render: function (data, type, row) {
            if (
              row.productos &&
              row.productos.length > 0 &&
              row.productos[0].precio != null
            ) {
              return GLOBAL.FORMATO_MONEY_BASIC(row.productos[0].precio);
            }
            return "-";
          },
        },
        {
          class: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.impuesto_total);
          },
        },
        {
          class: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.venta_total);
          },
        },
        {
          render: function (data, type, row) {
            try {
              if (typeof row.atributos.consecutivo_anterior == "undefined") {
                return "";
              } else {
                return (
                  row.atributos.consecutivo_anterior.prefijo +
                  "-" +
                  row.atributos.consecutivo_anterior.consecutivo
                );
              }
            } catch (error) {
              return "";
            }
          },
        },
        {
          class: "text-right",
          render: function (data, type, row) {
            if (GLOBAL.COUNTRY == "MX") {
              return row.public_hasp;
            } else {
              return "";
            }
          },
        },
        {
          render: (data, type, row) => this.estadoTexto(row, fechaActual),
        },
        {
          render: function (data, type, row) {
            if (GLOBAL.COUNTRY == "CO") {
              if (row.estado == "G") {
                if (row.url_factura != null) {
                  return (
                    "<a class='btn btn-sm btn-danger' href='" +
                    row.url_factura +
                    "' target='_blank' rel='noopener noreferrer'><i class='fa-solid fa-file-pdf'></i></a>"
                  );
                } else if (row.atributos != null) {
                  for (var d in row.atributos.operaciones) {
                    try {
                      if (row.atributos.operaciones[d].response.code == 201) {
                        var cune =
                          row.atributos.operaciones[d].response.data.cude;
                        return (
                          "<a class='btn btn-sm btn-danger' href='" +
                          row.parametros.electronica.url_factura +
                          "/" +
                          cune +
                          "/preview' target='_blank' rel='noopener noreferrer'><i class='fa-solid fa-file-pdf'></i></a>"
                        );
                        break;
                      }
                    } catch (error) {
                      console.log(row._id + " CON ERRORES");
                    }
                  }
                }
              } else if (row.estado == "I") {
                for (var d in row.atributos.operaciones) {
                  try {
                    if (row.atributos.anulacion.code == 201) {
                      var cune = row.atributos.anulacion.data.cude;
                      return (
                        "<a class='btn btn-sm btn-warning' href='" +
                        row.parametros.electronica.url_factura +
                        "/" +
                        cune +
                        "/preview' target='_blank' rel='noopener noreferrer'><i class='fa-solid fa-file-pdf'></i></a>"
                      );
                      break;
                    }
                  } catch (error) {
                    console.log(row._id + " CON ERRORES");
                  }
                }
              }
              return "";
            } else {
              return "";
            }
          },
        },
      ],
      createdRow: function (row, data) {
        let columna = 11;
        let host = GLOBAL.SERVER_HOST;
        const empresa = vm.empresa;

        if (GLOBAL.COUNTRY == "MX") {

          if (data.public_hasp == null) {

            // BOTON PREPARAR FACTURA NO EMITIDA 
            if (data.documento_id == GLOBAL.DOCUMENTO.FACTURA_ELECTRONICA) {
              var viewPRE = $("<a class='btn btn-sm btn-white' target='_blank' href='" + host + "/kubber/facturacion/api/v1/generate/" + empresa + "/" + data.uniqueid + "'><i class='fa-solid fa-file-pdf'></i> PRE FACTURA</a>");
              $("td", row).eq(columna).append(viewPRE);

              var enviarPRE = $("<button class='btn btn-sm btn-info' data-uniqueid='" + data.uniqueid + "'><i class='fa-solid fa-check'></i>EMITIR</button>");
              $(enviarPRE).on("click", function () { vm.reintentarFactura(data, this); });
              $("td", row).eq(columna).append(enviarPRE);

            }


            // BOTON CAMBIAR OPCIONES DE FACTURA NO EMITIDA
            var opcionesBtn = $("<button title='CAMBIAR OPCIONES DE FACTURA NO EMITIDA' class='btn btn-sm bg-indigo'><i class='fa-solid fa-money-check-dollar'></i></button>");
            $(opcionesBtn).on("click", function () { vm.opcionesFactura(data, this); });
            $("td", row).eq(columna).append(opcionesBtn);

            // BOTON INACTIVAR FACTURA NO EMITIDA
            var inactivarBtn = $("<button title='BORRAR FACTURA NO EMITIDA' class='btn btn-sm btn-danger'><i class='fa-solid fa-xmark'></i></button>");
            $(inactivarBtn).on("click", function () { vm.inactivarFactura(data, this); });
            $("td", row).eq(columna).append(inactivarBtn);

            // MOSTRAR EL BOTON DE REINTENTAR EL ENVÍO SI EL ESTADO ES REVISAR  O GENERADA SIN CDFI
            if (data.estado == "R" || data.estado == "G") {
              var deleteBtn = $("<button class='btn btn-sm btn-info' data-uniqueid='" + data.uniqueid + "'><i class='fa-solid fa-arrows-rotate'></i></button>");
              $(deleteBtn).on("click", function () { vm.reintentarFactura(data, this); });
              $("td", row).eq(columna).append(deleteBtn);
            }

          } else if (data.public_hasp != null && data.estado == "R") {

            if (data.estado == "R" || data.estado == "G") {
              var deleteBtn = $("<button class='btn btn-sm btn-info' data-uniqueid='" + data.uniqueid + "'><i class='fa-solid fa-arrows-rotate'></i></button>");
              $(deleteBtn).on("click", function () { vm.reintentarFactura(data, this); });
              $("td", row).eq(columna).append(deleteBtn);
            }

          }

          if (data.public_hasp == null && data.estado != "I") {

            // MOSTRAR EL BOTON DEL MOTIVO DEL ERROR
            if (data.response_remoto != null || data.response != null) {
              var infoBtn = $("<button class='btn btn-sm btn-primary'><i class='fa-sharp fa-solid fa-circle-info'></i></button>");
              $(infoBtn).on("click", function () { vm.showInfo(data, this); });
              $("td", row).eq(columna).append(infoBtn);
            }

          } else if (data.public_hasp == null || data.estado == "P") {

            // no hace nada extra aquí

          } else if (data.estado == "G") {


            // SI EL DOCUMENTO AUN NO HA TENIDO UN HASP PÚBLICO, ENTONCES SE PUEDE REINTENTAR EL ENVÍO.
            if (data.public_hasp == null) {

              // BOTON DE REENVIO DE FACTURA
              var consultaFactura = $("<button class='btn btn-sm btn-warning'><i class='fa-solid fa-triangle-exclamation'></i></button>");
              $(consultaFactura).on("click", function () { vm.consultaFactura(data, this); });
              $("td", row).eq(columna).append(consultaFactura);

            } else {

              // VER PDF 
              var viewPDF = $("<a class='btn btn-sm btn-danger' target='_blank' href='" + host + "/kubber/facturacion/api/v1/generate/" + empresa + "/" + data.uniqueid + "'><i class='fa-solid fa-file-pdf'></i></a>");
              $("td", row).eq(columna).append(viewPDF);

              // VER XML
              var viewXML = $("<a class='btn btn-sm bg-purple' target='_blank' href='" + host + "/kubber/facturacion/api/v1/generatexml/" + empresa + "/" + data.uniqueid + "'><i class='fa-solid fa-code'></i></a>");
              $("td", row).eq(columna).append(viewXML);

              // CANCELAR FACTURA
              var cancelBtn = $("<button class='btn btn-sm btn-secondary'><i class='fa-solid fa-trash'></i></button>");
              $(cancelBtn).on("click", function () { vm.cancelarFactura(data, this); });
              $("td", row).eq(columna).append(cancelBtn);

            }
          }
        }
      },
      dom:
        "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        {
          extend: "copyHtml5",
          text: '<i class="fa-regular fa-clipboard"></i>',
        },
        {
          extend: "excelHtml5",
          text: '<i class="fa-regular fa-file-excel"></i>',
        },
        {
          extend: "csvHtml5",
          text: '<i class="fa-solid fa-file-csv"></i>',
        },
        {
          extend: "pdfHtml5",
          text: '<i class="fa-regular fa-file-pdf"></i>',
        },
      ],
      scrollX: true,
      responsive: false,
      autoWidth: true,
      language: {
        url: "plugins/Spanish.json",
      },
    });

    this.getReporteEquipos();
    this.getCatalogos();
  },

  methods: {

    estadoTexto(row, fechaActual) {
      const base = {
        "P": "PENDIENTE",
        "B": "REVISAR/ANULAR",
        "R": "REVISAR",
        "C": "CANCELADA",
        "I": "ANULADA",
        "X": "PRUEBAS"
      };

      if (row.estado === "A") {
        let estado = "EMITIDA";
        const fechaRow = new Date(row.fecha);
        const minutos = (fechaActual - fechaRow) / (1000 * 60);
        if (row.documento_id === this.GLOBAL.DOCUMENTO.PREFORMA) {
          estado = minutos >= 5 ? "REVISAR" : "EN PROCESO...";
        }
        return estado;
      }

      if (row.estado === "G") {
        return row.public_hasp == null ? "PENDIENTE" : "EMITIDA";
      }

      return base[row.estado] ?? row.estado;
    },

    ymdHM(date, end = false) {
      const pad = n => n.toString().padStart(2, "0");
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);
      const d = pad(date.getDate());
      return `${y}-${m}-${d} ${end ? "23:59" : "00:00"}`;
    },

    initDateInputs() {
      const now = new Date();
      $("#fechainicio").val(this.ymdHM(now, false));
      $("#fechafin").val(this.ymdHM(now, true));
      $("input[datatype='fecha']").datetimepicker();
    },

    checkReasignarTercero() {
      if (this.isCheckedReasignarTercero) {
        this.opcionSeleccionada = "001-Reasignar Cliente";
      } else {
        this.opcionSeleccionada = "";
      }

      this.mensajeAnulacion = "";
    },

    limpiarCliente() {
      this.cliente = "";
    },

    showInfo(data /*, btn*/) {
      this.factura_error_item = data;

      const raw = (data?.response_remoto ?? data?.response ?? "").toString();
      const logError = raw.trim();
      this.mensajeError = "No se encontró detalle de error.";

      // Helpers
      const isLikelyJson = (s) => s.startsWith("{") || s.startsWith("[");
      const isLikelyXml = (s) => s.startsWith("<");

      const buildModelStateText = (modelState) => {
        if (!modelState || typeof modelState !== "object") return "";
        const lines = [];
        for (const [field, messages] of Object.entries(modelState)) {
          if (Array.isArray(messages)) {
            for (const msg of messages) lines.push(`${field}: ${msg}`);
          } else if (typeof messages === "string") {
            lines.push(`${field}: ${messages}`);
          } else if (messages != null) {
            lines.push(`${field}: ${JSON.stringify(messages)}`);
          }
        }
        return lines.join("\n");
      };

      // 1) JSON
      if (logError && isLikelyJson(logError)) {
        try {
          const obj = JSON.parse(logError);

          const msg =
            (obj?.Message ?? obj?.message ?? obj?.error_description ?? obj?.error ?? "").toString().trim();

          const msText = buildModelStateText(obj?.ModelState ?? obj?.modelState);

          // Si hay ModelState, suele ser lo más útil
          this.mensajeError = (msText || msg || this.mensajeError).trim();

          // Si ambos existen, concatenarlos
          if (msText && msg) this.mensajeError = `${msg}\n${msText}`.trim();

          $("#myChange").modal("show");
          return;
        } catch {
          // si parece JSON pero viene malformado, cae al fallback
        }
      }

      // 2) XML (tu caso original)
      if (logError && isLikelyXml(logError)) {
        try {
          const xmlDoc = new DOMParser().parseFromString(logError, "text/xml");

          // Si hay error de parseo XML, algunos navegadores meten <parsererror>
          if (xmlDoc.getElementsByTagName("parsererror").length) {
            throw new Error("XML inválido");
          }

          const e1 = xmlDoc.getElementsByTagName("b:ErrorDesc")[0]?.textContent ?? "";
          const e2 = xmlDoc.getElementsByTagName("b:ErrorMessage")[0]?.textContent ?? "";

          this.mensajeError = `${e1}${e2}`.trim() || this.mensajeError;

          $("#myChange").modal("show");
          return;
        } catch {
          // sigue al fallback
        }
      }

      // 3) Fallback: texto plano (o contenido desconocido)
      if (logError) {
        this.mensajeError = logError;
      }

      $("#myChange").modal("show");
    },


    // Botón del modal: "Borrar este mensaje y reenviar"
    reprocesarError() {
      if (!this.factura_error_item) {
        this.mensajeError = "No se encontró la factura asociada al error.";
        return;
      }

      const uid = this.factura_error_item.uniqueid;
      const $btn = $(`#table2 button.btn-info[data-uniqueid="${uid}"]`);

      $("#myChange").modal("hide");
      this.mensajeError = "";

      // Reintentar con borrar_cache = true, usando el mismo botón si existe
      this.reintentarFactura(
        this.factura_error_item,
        $btn.length ? $btn[0] : null,
        true
      );
    },

    // reintentarFactura ahora recibe borrarCache (por defecto false)
    reintentarFactura(item, btn, borrarCache = false) {
      if (btn) {
        $(btn).addClass("btn-loading");
        $(btn).attr("disabled", true);
        $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
      }

      var request = {
        uniqueid: item.uniqueid,
      };

      if (borrarCache) {
        request.borrar_cache = true;
      }

      const done = () => {
        if (btn) {
          $(btn).removeClass("btn-loading");
          $(btn).attr("disabled", false);
          $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
        }
        this.getReporteEquipos();
      };

      if (item.documento_id == GLOBAL.DOCUMENTO.FACTURA_ELECTRONICA) {
        this.reporteService
          .reintentarEnvioFacturaMexico(this.person, request)
          .then(done);
      } else {
        this.reporteService
          .reintentarNotaCreditoMexico(this.person, request)
          .then(done);
      }
    },

    reintentarEnvioFacturaColombia(item, btn) {
      $(btn).html("<i class='fa-solid fa-arrows-rotate fa-spin'></i>");
      $(btn).attr("disabled", true);
      var request = {
        uniqueId: item.uniqueid,
      };
      this.reporteService
        .reintentarEnvioFacturaColombia(this.person, request)
        .then((data) => {
          this.reporteService
            .reintentarEnvioFacturaColombia(this.person, request)
            .then((data) => {
              $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
              $(btn).attr("disabled", false);
              this.getReporteEquipos();
            });
        });
    },

    consultaFactura(item, btn) {
      $(btn).html("<i class='fa-solid fa-arrows-rotate fa-spin'></i>");
      $(btn).attr("disabled", true);
      var request = {
        uniqueid: item.uniqueid,
      };
      this.reporteService
        .reintentarConsultaFactura(this.person, request)
        .then((data) => {
          $(btn).html("<i class='fa-solid fa-arrows-rotate'></i>");
          $(btn).attr("disabled", false);
          this.getReporteEquipos();
        });
    },

    cancelarFactura(item) {
      this.opcionSeleccionada = "";
      this.factura_eliminar = item.prefijo + "-" + item.consecutivo;
      this.desabilitarBotonCancelar = false;

      this.factura_eliminar_uniqueid = item.uniqueid;

      if (GLOBAL.COUNTRY == "MX") {

        this.factura_eliminar_remotoid = item.tercero_hasp;
        console.log("Hasp remoto ID para cancelación:", item);


        $("#ModalCancel").modal("show");
      }
    },

    // ModalInactivar
    inactivarFactura(item) {
      this.opcionSeleccionada = "";
      this.factura_eliminar = item.prefijo + "-" + item.consecutivo;
      this.desabilitarBotonCancelar = false;

      this.factura_eliminar_uniqueid = item.uniqueid;

      if (GLOBAL.COUNTRY == "MX") {
        $("#ModalInactivar").modal("show");
      }
    },

    enviarCancelacionFactura() {
      var valido = "OK";

      if (
        this.opcionSeleccionada == null ||
        this.opcionSeleccionada.trim() == ""
      ) {
        valido = "Debe escribir un motivo de anulación";
      }

      if (this.isCheckedReasignarTercero && this.cliente == "") {
        valido = "Debe seleccionar a un cliente";
      }

      if (valido == "OK") {
        this.mensajeAnulacion = "";
        const request = {
          uniqueId: this.factura_eliminar_uniqueid,
          remotoId: this.factura_eliminar_remotoid,
          cancelacion: this.opcionSeleccionada,
          terceroUnique: "",
        };

        if (this.isCheckedReasignarTercero) {
          request.terceroUnique = this.cliente;
        }

        this.desabilitarBotonCancelar = true;
        this.facturadorService
          .enviarCancelacionFactura(this.person, request)
          .then((data) => {
            $("#ModalCancel").modal("hide");

            this.desabilitarBotonCancelar = false;
            this.item = [];
            this.getReporteEquipos();
            this.factura_eliminar_remotoid = null;
          });
      } else {
        this.mensajeAnulacion = valido;
      }
    },

    confirmarInactivarFactura() {
      var valido = "OK";

      if (
        this.motivoInactivacion == null ||
        this.motivoInactivacion.trim() == ""
      ) {
        valido = "Debe escribir un motivo de anulación";
      }

      if (valido == "OK") {
        this.mensajeAnulacion = "";
        const request = {
          uniqueId: this.factura_eliminar_uniqueid,
          remotoId: this.factura_eliminar_remotoid,
          motivo: this.motivoInactivacion
        };

        this.desabilitarBotonCancelar = true;
        this.facturadorService
          .enviarInactivacionFactura(this.person, request)
          .then((data) => {
            $("#ModalInactivar").modal("hide");

            this.mensajeAnulacion = "";
            this.motivoInactivacion = "";
            this.desabilitarBotonCancelar = false;
            this.item = [];
            this.getReporteEquipos();
            this.factura_eliminar_remotoid = null;

          });

      } else {
        this.mensajeInactivacion = valido;
      }
    },

    getCatalogos() {
      if (this.catalogo == null) {
        this.facturadorService.getCatalogos(this.person).then((data) => {
          var json = data;
          for (const i in json) {
            switch (json[i].tipo) {
              case GLOBAL.CATALOGO_MEXICO.METODO_PAGO:
                this.lista_metodo_pago.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.FORMA_PAGO:
                this.lista_forma_pago.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.USO_CFDI:
                this.lista_uso_cfdi.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.TIPO_VENTA:
                this.lista_tipo_venta.push(json[i]);
                break;
              case GLOBAL.CATALOGO_MEXICO.PERIORICIDAD:
                this.lista_perioricidad.push(json[i]);
                break;
              default:
                break;
            }
          }
        });
      }
    },

    async getReporteEquipos() {
      this.datatable.page(0).draw(false);
      this.reporte = [];
      const fechainicio = $("#fechainicio").val();
      const fechafin = $("#fechafin").val();
      this.loading = true;

      try {
        const data = await this.reporteService.getListaMovimientosDocumentos(
          this.person, fechainicio, fechafin, this.tipo
        );
        this.reporte = Array.isArray(data) ? data : [];

        // Totales compactos
        const agg = this.reporte.reduce((a, r) => ({
          totalimpuestos: a.totalimpuestos + (r.impuesto_total || 0),
          totalCantidad: a.totalCantidad + (r.cantidad || 0),
          totales: a.totales + (r.venta_total || 0),
          totalventas: a.totalventas + 1
        }), { totalimpuestos: 0, totalCantidad: 0, totales: 0, totalventas: 0 });

        Object.assign(this, {
          totalimpuestos: agg.totalimpuestos,
          totalCantidad: agg.totalCantidad,
          totales: agg.totales,
          totalventas: agg.totalventas,
          fcantidad: this.GLOBAL.FORMATO_NUMBER(agg.totalCantidad),
          ftotalimpuestos: this.GLOBAL.FORMATO_MONEY(agg.totalimpuestos),
          ftotales: this.GLOBAL.FORMATO_MONEY(agg.totales),
          fecha_inicio_reporte: fechainicio,
          fecha_final_reporte: fechafin
        });

        // Refrescar DT
        this.datatable.clear().rows.add(this.reporte).draw();
      } finally {
        this.loading = false;
      }
    },

    // ModalOpciones
    opcionesFactura(item) {

      this.opcionSeleccionada = "";
      this.factura_eliminar = item.prefijo + "-" + item.consecutivo;
      this.factura_eliminar_uniqueid = item.uniqueid;
      this.factura_eliminar_item = item;

      this.metodo_pago = item.atributos.metodo_pago;
      this.forma_pago = item.atributos.forma_pago;
      this.uso_cfdi = item.atributos.uso_cfdi;
      this.tipo_venta = item.atributos.tipo_venta;
      this.perioricidad = item.atributos.perioricidad;
      this.observaciones = item.atributos.observaciones;

      if (item.tercero_nit != "XAXX010101000") {
        this.desabilitarPerioricidad = true;
      } else {
        this.desabilitarPerioricidad = false;
      }

      if (GLOBAL.COUNTRY == "MX") {
        $("#ModalOpciones").modal("show");
      }
    },

    confirmarCambioOpcionesFactura() {
      // Validación individual de cada campo
      if (!this.metodo_pago || this.metodo_pago === "") {
        this.mensajCambioOpciones = "Debe seleccionar el método de pago.";
        return;
      }
      if (!this.forma_pago || this.forma_pago === "") {
        this.mensajCambioOpciones = "Debe seleccionar la forma de pago.";
        return;
      }
      if (!this.uso_cfdi || this.uso_cfdi === "") {
        this.mensajCambioOpciones = "Debe seleccionar el uso de CFDI.";
        return;
      }
      if (!this.tipo_venta || this.tipo_venta === "") {
        this.mensajCambioOpciones = "Debe seleccionar el tipo de venta.";
        return;
      }
      if (this.factura_eliminar_item.tercero_nit == "XAXX010101000") {
        if (!this.perioricidad || this.perioricidad === "") {
          this.mensajCambioOpciones = "Debe seleccionar la periodicidad.";
          return;
        }
      }
      // Si todo está correcto, limpiar mensaje y continuar
      this.mensajCambioOpciones = "";

      const request = {
        uniqueId: this.factura_eliminar_uniqueid,
        metodo_pago: this.metodo_pago,
        forma_pago: this.forma_pago,
        uso_cfdi: this.uso_cfdi,
        tipo_venta: this.tipo_venta,
        perioricidad: this.perioricidad,
        observaciones: this.observaciones,
        atributos: this.factura_eliminar_item.atributos
      };

      this.desabilitarBotonCancelar = true;
      this.facturadorService
        .enviarCambioOpcionesFactura(this.person, request)
        .then((data) => {
          $("#ModalOpciones").modal("hide");
          this.mensajCambioOpciones = "";
          this.item = [];
          this.getReporteEquipos();
        });
    },

  },
};
</script>




<style scope>
/* ANIMACIÓN DEL BOTÓN DE REPROCESO */
.btn-loading {
  pointer-events: none !important;
  opacity: 0.9;
}

.btn-loading i {
  animation: spinPulse 1s infinite;
  display: inline-block;
}

.btn-white {
  background-color: #406b00;
  color: #ffffff;
  border: 1px solid #cccccc;
}

@keyframes spinPulse {
  0% {
    transform: rotate(0deg) scale(1);
  }

  100% {
    transform: rotate(360deg) scale(1);
  }
}
</style>